module.exports = __webpack_public_path__ + "img/11.6d390cb1.jpg";